import { lazy } from 'react';

// ----------------------------------------------------------------------

const PosPage = lazy(() => import('../pages/Pos.page'));

// ----------------------------------------------------------------------

const PosRoutes = [
    {
        path: '/point-of-sale',
        element: <PosPage />,
        layout: 'default',
        isAuthReq: true,
    },
];

export { PosRoutes };
